import { cn } from "@/lib/utils";

interface RedFlagsEmptyCardProps {
  className?: string;
}

function CheckIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M16.667 5L7.5 14.167 3.333 10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RedFlagsEmptyCard({ className }: RedFlagsEmptyCardProps) {
  return (
    <div
      className={cn(
        "flex overflow-clip rounded-xl border border-forest-100 bg-success-soft/40",
        className
      )}
    >
      <div className="w-1 shrink-0 bg-success" />
      <div className="flex items-start gap-3 p-5">
        <CheckIcon className="mt-0.5 shrink-0 text-success" />
        <div className="flex flex-col gap-1">
          <p className="font-semibold text-success">No red flags this session</p>
          <p className="text-sm leading-relaxed text-muted-strong">
            No clinical or counseling concerns were identified in this session.
          </p>
        </div>
      </div>
    </div>
  );
}
